import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab } from '@mui/material';
import FeeOverviewTab from './FeeOverviewTab';
import HowsTab from './HowsTab';
export default function FeeStructurePage() {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const tabs = [
  // {
  //   label: 'Fee overview',
  //   value: 'overview',
  // },
  {
    label: t('fees_page.how_fee'),
    value: 'hows'
  }];
  const _useState = useState('hows'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleSelectedTabChange = (event, newValue) => setSelectedTab(newValue);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    type: "navigation",
    position: "sticky",
    value: selectedTab,
    onChange: handleSelectedTabChange,
    "aria-label": "tabs navigation"
  }, tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.value,
    value: tab.value,
    label: tab.label,
    'custom-attribute': '756-FeeStructurePage-page-' + tab.value
  }))), selectedTab === 'overview' && /*#__PURE__*/React.createElement(FeeOverviewTab, null), selectedTab === 'hows' && /*#__PURE__*/React.createElement(HowsTab, null));
}